import { Card, Image, makeStyles, Skeleton, SkeletonItem, Title1, Title3 } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../utils/Theme";

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        gap: '20px',
        backgroundColor: '#f5f5f5',
    },
    headerImageContainer: {
        position: "relative",
        width: "100%",
        maxWidth: "800px",
        height: "300px",
        margin: 0,
        borderRadius: '8px',
        overflow: 'hidden',
    },
    headerImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    section: {
        width: '100%',
        maxWidth: '800px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    overview: {
        marginTop: 0
    },
    title: {
        marginBottom: 0
    },
    subtitle: {
        marginTop: 0,
        marginBottom: "1rem",
        color: dolphinTokens.colorLightBlue,
        fontWeight: "normal"
    },
    field: {
        margin: '1rem 0',
    },
    skeletons: {
        marginBottom: '1rem',

        "&:last-child": {
            marginBottom: 0
        }
    },
    skeleton: {
        margin: '.25rem 0',
        width: '100%',
    }
});

export default function Placeholder() {
    const { t } = useTranslation(["blog", "general"]);
    const styles = useStyles();

    return (
        <div>
                
            <div className={styles.container}>
                <div className={styles.headerImageContainer}>
                    <Image src="/video/top-banner-video-preview.webp" alt={t("companyName", { ns: "general" })} className={styles.headerImage} />
                </div>

                <Card className={`${styles.section} ${styles.overview}`}>
                    <Title1 block as="h1" align="center" className={styles.title}>
                        {t("loading", { ns: "general" })}
                    </Title1>

                    {
                        <Title3 block as="h3" align="center" className={styles.subtitle}>
                            {t("companyName", { ns: "general" })}
                        </Title3>
                    }
                    
                </Card>

                <Card className={styles.section}>
                    <div className={styles.field}>
                        <div>
                            {
                                Array.from({ length: 5 }).map((_, index) => (
                                    <div key={index} className={styles.skeletons}>
                                        {
                                            Array.from({ length: 3 }).map((_, i) => (
                                                <Skeleton key={index} className={styles.skeleton}>
                                                    <SkeletonItem size={20} />
                                                </Skeleton>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}